export default "__VITE_ASSET__BWQcCgAF__"